import { render } from "./EyeClosedIcon.vue?vue&type=template&id=c3fb3ac4"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__